// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"07e1e5a252","253":"d08d9bccff","619":"16c1450d30"}[chunkId] + ".js";
};